/* eslint-disable import/prefer-default-export */

export const APIURL = document.location.href.includes('commons.test.datacite.org') ? 'https://api.test.datacite.org' : 'https://api.datacite.org';
